import React from 'react';
import { ActivityIndicator, Animated, View } from 'react-native';

import { SizedBox } from '@/components/SizedBox';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { nativeDriverValue } from '@/utils/constants-platform-specific';

import { CasinoTransaction } from '../hooks/use-casino-history';
import { CasinoHistoryCard } from './CasinoHistoryCard';

type LoadingMoreProps = { isFetchingNextPage: boolean };

const LoadingMore = ({ isFetchingNextPage }: LoadingMoreProps) => {
    return isFetchingNextPage ? (
        <View>
            <SizedBox value={8} />
            <ActivityIndicator />
            <SizedBox value={8} />
        </View>
    ) : null;
};

type CasinoHistoryListProps = {
    transactions: CasinoTransaction[];
    fetchNextPage: () => void;
    isFetchingNextPage: boolean;
    scrollAnim: React.MutableRefObject<Animated.Value>;
};

export const CasinoHistoryList = ({
    transactions,
    fetchNextPage,
    isFetchingNextPage,
    scrollAnim,
}: CasinoHistoryListProps) => {
    return (
        <Animated.FlatList
            testID="casinoHistoryList"
            data={transactions}
            onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: scrollAnim.current } } }], {
                useNativeDriver: nativeDriverValue,
            })}
            renderItem={({ item }) => (
                <MaxWidthWrapper paddingHorizontal={'s16'}>
                    <CasinoHistoryCard transaction={item} />
                </MaxWidthWrapper>
            )}
            keyExtractor={item => item.bet_id}
            onEndReachedThreshold={0.5}
            onEndReached={fetchNextPage}
            ListFooterComponent={<LoadingMore isFetchingNextPage={isFetchingNextPage} />}
        />
    );
};
